import _ from 'lodash';

export const event_networkId = function(network) {
  return network?.id ? {
    event: {
      $where: {
        networkId: network.id
      }
    }
  } : {};
};

export const project_networkId = function(network) {
  return network?.id ? {
    project: {
      $where: {
        networkId: network.id
      }
    }
  } : {};
};

export const offer_networkId = function(network) {
  return network?.id ? {
    offer: {
      $where: {
        networkId: network.id
      }
    }
  } : {};
};

export const user_networkId = function(network) {
  return network?.id ? {
    user: {
      $where: {
        networkId: network.id
      }
    }
  } : {};
};

export const tagNodes_tagId = function(tag) {
  return {
    tagNodes: {
      $where: {
        tagId: tag.id
      }
    }
  }
};

export const tagNodes_tagType = function(tag) {
  switch (tag?.data?.type) {
    case 'Subject': return 'subjects';
    case 'Grade': return 'grades';
    case 'Practice': return 'practices';
    case 'Age': return 'ages';
    case 'ExpertiseType': return 'skills';
    case 'Activity': return 'activities';
    case 'Experience': return 'experiences';
    case 'Guidance': return 'guidances';
    case 'Group': return 'groups';
    default: return tag?.data?.type;
  }
};

export const user_tags_educator = function() {
  return {
    user: {
      $where: {
        tags: {
          $where: {
            type: 'Intent',
            name: 'Educator'
          }
        }
      }
    }
  };
};

export const user_tags_partner = function() {
  return {
    user: {
      $where: {
        tags: {
          $where: {
            type: 'Intent',
            name: 'Partner'
          }
        }
      }
    }
  };
};

export const creator_tags_educator = function() {
  return {
    creator: {
      $where: {
        tags: {
          $where: {
            type: 'Intent',
            name: 'Educator'
          }
        }
      }
    }
  };
};

export const creator_tags_partner = function() {
  return {
    creator: {
      $where: {
        tags: {
          $where: {
            type: 'Intent',
            name: 'Partner'
          }
        }
      }
    }
  };
};

export const tags_educator = function() {
  return {
    tags: {
      $where: {
        type: 'Intent',
        name: 'Educator'
      }
    },
    // tagNodes: {
    //   $where: {
    //     tag: {
    //       $where: {
    //         type: 'Intent',
    //         name: 'Educator'
    //       }
    //     }
    //   }
    // }
  };
};

export const tags_partner = function() {
  return {
    tags: {
      $where: {
        type: 'Intent',
        name: 'Partner'
      }
    }
  };
};

export const site_state_$ilike = function(state) {
  return {
    site: {
      $where: {
        state: {
          $ilike: state
        }
      }
    }
  };
};

export const site_name_$ilike_includes = function(word) {
  return {
    site: {
      $where: {
        name: {
          $ilike: `%${word}%`
        }
      }
    }
  };
};

export const creator_state_$ilike = function(state) {
  return {
    creator: {
      $where: {
        state: {
          $ilike: state
        }
      }
    }
  };
};

export const creator_firstName_$ilike_includes = function(word) {
  return {
    creator: {
      $where: {
        firstName: {
          $ilike: `%${word}%`
        }
      }
    }
  };
};

export const creator_lastName_$ilike_includes = function(word) {
  return {
    creator: {
      $where: {
        lastName: {
          $ilike: `%${word}%`
        }
      }
    }
  };
};

export const user_firstName_$ilike_includes = function(word) {
  return {
    user: {
      $where: {
        firstName: {
          $ilike: `%${word}%`
        }
      }
    }
  };
};

export const user_lastName_$ilike_includes = function(word) {
  return {
    user: {
      $where: {
        lastName: {
          $ilike: `%${word}%`
        }
      }
    }
  };
};

export const activity_name_$ilike_includes = function(word) {
  return {
    activity: {
      $where: {
        name: {
          $ilike: `%${word}%`
        }
      }
    }
  };
};

export const school_agencyName_$ilike_includes = function(word) {
  return {
    school: {
      $where: {
        agencyName: {
          $ilike: `%${word}%`
        }
      }
    }
  }
};

export const tags_type_count_$gte = function(type, value) {
  return {
    tags: {
      $where: {
        type: type
      },
      $having: {
        count: {
          $gte: value
        }
      }
    }
  }
};

export const tags_type_count_$lte = function(type, value) {
  return {
    tags: {
      $where: {
        type: type
      },
      $having: {
        count: {
          $lte: value
        }
      }
    }
  }
};

export const $aggregations_distance = function(distance = {}, relation = '') {
  const fromParams = _.pick(distance, ['latitude', 'longitude']);
  const hasDistanceQuery = Object.keys(fromParams).length === 2;

  return hasDistanceQuery ? [
    {
      alias: 'distance',
      relation: relation,
      type: 'distance',
      from: fromParams
    }
  ] : undefined;
};

export const $aggregation_distance = function(distance = {}, relation = '') {
  const fromParams = _.pick(distance, ['latitude', 'longitude']);
  const hasDistanceQuery = Object.keys(fromParams).length === 2;

  return hasDistanceQuery ? {
    alias: 'distance',
    relation: relation,
    type: 'distance',
    from: fromParams
  } : undefined;
};
